import { render, staticRenderFns } from "./Predictions.vue?vue&type=template&id=7ecde142"
import script from "./Predictions.vue?vue&type=script&lang=js"
export * from "./Predictions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports